module.exports = __webpack_public_path__ + "img/info-dark.692dccc0.png";